<template>
  <div class="columns is-multiline is-vcentered" v-if="isAvailable">
    <div class="column is-12-desktop is-6-widescreen">
      <h3 class="title mb-1 is-size-4 is-size-5-mobile">{{ $t('payment.amazon-pay.header') }}</h3>
      <p class="mb-4">
        {{ $t('payment.amazon-pay.fast_safe_amzn_payment') }}
      </p>
    </div>
    <div class="column is-12-desktop is-6-widescreen">
      <div id="amazon-pay-button"></div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'AmazonPayButton',
  data() {
    return {
      isAvailable: `${process.env.VUE_APP_AMZN_WIDGET}` && `${process.env.VUE_APP_AMZN_WIDGET}`.length > 0,
    }
  },
  computed: {
    ...mapActions({
      startSession: '$_checkout/createAmazonCheckoutSession',
      locale: 'locale',
    }),
  },
  methods: {
    prepare() {
      if ('amazon' in window) {
        this.init()
      } else {
        let amaPayButtons = document.createElement('script')
        amaPayButtons.setAttribute('src', `${process.env.VUE_APP_AMZN_WIDGET}`)
        document.head.appendChild(amaPayButtons)
        this.init()
      }
    },
    init() {
      var pollId = setInterval(poll, 250)
      const tryInit = () => this.initButton()
      function poll() {
        if (!window.amazon) return
        clearTimeout(pollId)
        tryInit()
      }
    },
    async initButton() {
      //render server side and then render button
      //https://amazonpaycheckoutintegrationguide.s3.amazonaws.com/amazon-pay-checkout/add-the-amazon-pay-button.html
      try {
        let res = await this.startSession
        res.checkoutLanguage = this.$store.getters.localeIso

        window.amazon.Pay.renderButton('#amazon-pay-button', res)
      } catch (e) {
        this.isAvailable = false
      }
    },
  },
  async mounted() {
    if (this.isAvailable) {
      this.prepare()
    }
  },
}
</script>
